import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { useSelector } from "react-redux";
import { isEmptyObject, useOuterClick } from "../../helpers";
const ApplicantFilter = (props) => {
  const [position, SetPosition] = useState([]);
  const [jobStatus, SetJobStatus] = useState([]);
  const [noticePeriod, setNoticePeriod] = useState([]);
  const [assignToMe, setAssignToMe] = useState(null);
  const [source, setSource] = useState([]);
  useEffect(() => {
    if (!isEmptyObject(props?.filterData)) {
      if (props?.filterData?.applicationStatus) {
        SetJobStatus(props?.filterData?.applicationStatus);
        let inputs = document.querySelectorAll('input[name="statusCheckbox"]');
        for (let i = 0; i < inputs.length; i++) {
          if (props?.filterData?.applicationStatus.includes(inputs[i].value)) {
            inputs[i].checked = true;
          }
        }
      }
      if (props?.filterData?.position) {
        SetPosition(props?.filterData?.position);
        let inputs = document.querySelectorAll(
          'input[name="positionCheckbox"]'
        );
        for (let i = 0; i < inputs.length; i++) {
          if (props?.filterData?.position.includes(inputs[i].value)) {
            inputs[i].checked = true;
          }
        }
      }
      if (props?.filterData?.noticePeriod) {
        setNoticePeriod(props?.filterData?.noticePeriod);
        let inputs = document.querySelectorAll('input[name="noticeCheckBox"]');
        for (let i = 0; i < inputs.length; i++) {
          if (props?.filterData?.noticePeriod.includes(inputs[i].value)) {
            inputs[i].checked = true;
          }
        }
      }

      if (props?.filterData?.source) {
        setSource(props?.filterData?.source);
        let inputs = document.querySelectorAll('input[name="sourceCheckBox"]');
        for (let i = 0; i < inputs.length; i++) {
          if (props?.filterData?.source.includes(inputs[i].value)) {
            inputs[i].checked = true;
          }
        }
      }
      if (props?.filterData?.userId) {
        setAssignToMe(props?.filterData?.userId)
        let inputs = document.querySelectorAll('input[name="AssToCheckbox"]');
        for (let i = 0; i < inputs.length; i++) {
          if (props?.filterData?.userId === inputs[i].value) {
            inputs[i].checked = true;
          }
        }
      }
    } else {
      uncheckAll();
    }
  }, [props?.filterData]);

  useEffect(() => {
    if (props?.appStatus !== null) {
      SetJobStatus([props?.appStatus]);
      let inputs = document.querySelectorAll('input[name="statusCheckbox"]');
      for (let i = 0; i < inputs.length; i++) {
        if ([props?.appStatus].includes(inputs[i].value)) {
          inputs[i].checked = true;
        }
      }
    }
  }, [props?.appStatus]);

  const handleFilter = () => {
    let res = {};
    if (position.length > 0) {
      res["position"] = position;
    }
    // if (jobStatus.length > 0) {
    //   res["applicationStatus"] = jobStatus;
    // }
    if (noticePeriod.length > 0) {
      res["noticePeriod"] = noticePeriod;
    }
    // if (assignToMe !== null) {
    //   res["userId"] = assignToMe;
    // }

    if (source.length > 0) {
      res["source"] = source;
    }

    props.hangleFilterOption(res);
    props.setChannelPopover(false);
  };

  const assineChange = (e) => {
    if (e.target.value && e.target.checked) {
      setAssignToMe(e.target.value);
    } else {
      setAssignToMe(null);
    }
  };

  const positionChange = (e) => {
    let arr = position;
    if (
      e.target.value &&
      !position.includes(e.target.value) &&
      e.target.checked
    ) {
      arr.push(e.target.value);
    } else {
      if (arr.length > 0) {
        const index = arr.indexOf(e.target.value);
        if (index > -1) {
          arr.splice(index, 1);
        }
      }
    }
    SetPosition(arr);
  };

  const jobStChange = (e) => {
    let arr = jobStatus;
    if (
      e.target.value &&
      !jobStatus.includes(e.target.value) &&
      e.target.checked
    ) {
      arr.push(e.target.value);
    } else {
      if (arr.length > 0) {
        const index = arr.indexOf(e.target.value);
        if (index > -1) {
          arr.splice(index, 1);
        }
      }
    }
    SetJobStatus(arr);
  };

  const noticeChange = (e) => {
    let arr = noticePeriod;
    if (
      e.target.value &&
      !noticePeriod.includes(e.target.value) &&
      e.target.checked
    ) {
      arr.push(e.target.value);
    } else {
      if (arr.length > 0) {
        const index = arr.indexOf(e.target.value);
        if (index > -1) {
          arr.splice(index, 1);
        }
      }
    }
    setNoticePeriod(arr);
  };

  const sourceChange = (e) => {
    let arr = source;
    if (
      e.target.value &&
      !source.includes(e.target.value) &&
      e.target.checked
    ) {
      arr.push(e.target.value);
    } else {
      if (arr.length > 0) {
        const index = arr.indexOf(e.target.value);
        if (index > -1) {
          arr.splice(index, 1);
        }
      }
    }
    setSource(arr);
  };

  function uncheckAll() {
    document
      .querySelectorAll('input[type="checkbox"]')
      .forEach((el) => (el.checked = false));
  }

  const resetFilter = () => {
    SetPosition([]);
    SetJobStatus([]);
    setNoticePeriod([]);
    uncheckAll();
    props.setChannelPopover(false);

    props.hangleFilterOption({});
  };

  const innerRef = useOuterClick((e) => {
    if (e.target.id != "filter-button") {
      props.setChannelPopover(false);
    }
  });
  const user = useSelector((state) => state.authentication.user);
  return (
    <>
      <div ref={innerRef}>
        <Accordion allowMultipleExpanded allowZeroExpanded>
          {/* <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Assigneed</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="check-list">
                <li className="input-items">
                  <input
                    type="checkbox"
                    value={user?.userId}
                    name="AssToCheckbox"
                    id="AssToCheckbox"
                    onChange={(e) => assineChange(e)}
                  />
                  To Me
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem> */}
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Position</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="check-list">
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Full Time"
                    name="positionCheckbox"
                    onChange={(e) => positionChange(e)}
                  />
                  Full Time
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Part Time"
                    name="positionCheckbox"
                    onChange={(e) => positionChange(e)}
                  />
                  Part Time
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Intern"
                    name="positionCheckbox"
                    onChange={(e) => positionChange(e)}
                  />
                  Intern
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Contractual"
                    name="positionCheckbox"
                    onChange={(e) => positionChange(e)}
                  />
                  Contractual
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem>

          {/* <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Status</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="check-list">
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Not Started"
                    name="statusCheckbox"
                    onChange={(e) => jobStChange(e)}
                  />
                  Not Started
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="First Round"
                    name="statusCheckbox"
                    onChange={(e) => jobStChange(e)}
                  />
                  Move to 1st round
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Second Round"
                    name="statusCheckbox"
                    onChange={(e) => jobStChange(e)}
                  />
                  Move to 2nd round
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="HR Round"
                    name="statusCheckbox"
                    onChange={(e) => jobStChange(e)}
                  />
                  HR Round
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Selected"
                    name="statusCheckbox"
                    onChange={(e) => jobStChange(e)}
                  />
                  Selected
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="On Board"
                    name="statusCheckbox"
                    onChange={(e) => jobStChange(e)}
                  />
                  On Board
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Hold"
                    name="statusCheckbox"
                    onChange={(e) => jobStChange(e)}
                  />
                  Hold
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="Rejected"
                    name="statusCheckbox"
                    onChange={(e) => jobStChange(e)}
                  />
                  Rejected
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem> */}
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Notice Period</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="check-list">
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="0"
                    name="noticeCheckBox"
                    onChange={(e) => noticeChange(e)}
                  />
                  Immediate
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="0.5"
                    name="noticeCheckBox"
                    onChange={(e) => noticeChange(e)}
                  />
                  15 days
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="1"
                    name="noticeCheckBox"
                    onChange={(e) => noticeChange(e)}
                  />
                  1 Months
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="2"
                    name="noticeCheckBox"
                    onChange={(e) => noticeChange(e)}
                  />
                  2 Months
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="3"
                    name="noticeCheckBox"
                    onChange={(e) => noticeChange(e)}
                  />
                  3 Months
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Source</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="check-list">
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="0"
                    name="sourceCheckBox"
                    onChange={(e) => sourceChange(e)}
                  />
                  Internal
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="1"
                    name="sourceCheckBox"
                    onChange={(e) => sourceChange(e)}
                  />
                  External
                </li>
                <li className="input-items">
                  <input
                    type="checkbox"
                    value="2"
                    name="sourceCheckBox"
                    onChange={(e) => sourceChange(e)}
                  />
                  Careers
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
        <div className="button-group">
          <button
            className="proceedBtn"
            onClick={() => {
              handleFilter();
            }}
          >
            Apply
          </button>
          <button
            className="resetBtn"
            onClick={() => {
              resetFilter();
            }}
          >
            Reset
          </button>
        </div>
      </div>
    </>
  );
};

export default ApplicantFilter;
